// extracted by mini-css-extract-plugin
export default {"cls1":"Star-cls1_xur","cls2":"Star-cls2_OHy Star-cls1_xur","selected":"Star-selected__Fr","hovered":"Star-hovered_xC9"};